import api from '@/plugins/axios'

const base = 'v1/site/'

export default {
    getNameRFB(cnpj) {
        return api.get(base + `razao-social-fantasia?cnpj=${cnpj}`)
    }
}
